var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavShoppingcart = function SvgNavShoppingcart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78 17.128a1.427 1.427 0 1 1 0 2.854 1.427 1.427 0 0 1 0-2.854Zm11.348 0a1.427 1.427 0 1 1 0 2.854 1.427 1.427 0 0 1 0-2.854ZM1.57 0a2.08 2.08 0 0 1 2.044 1.643l.026.141.5 2.498h13.987c.57 0 1.07.214 1.427.642.321.386.469.887.443 1.4l-.015.17-1.142 7.565c-.135.881-.915 1.57-1.85 1.636l-.148.005H5.995c-.952 0-1.774-.776-1.973-1.775l-.026-.152-1.141-8.278-.643-3.497a.688.688 0 0 0-.557-.564l-.085-.007H.714A.715.715 0 0 1 .61.007L.714 0h.856Z",
    fill: "var(--primaryColor)"
  })));
};

export default SvgNavShoppingcart;